import http from "./http.service";


export const getBookinglist = async (payload:any) => {
    return http.get(`/partner/bookings`,{params:payload});
}

export const getBookingDetails = async (id:any) => {
    return http.get(`/partner/booking/${id}`);
}

export const cancelBooking = async (id:any) => {
    return http.put(`/partner/booking/cancel/${id}`);
}

